goog.provide('yext.location.Education');
goog.provide('yext.location.EducationModel');

goog.require('yext');
goog.require('yext.helpers');
goog.require('yext.location.helpers');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');
/** @suppress {extraRequire} */
goog.require('yext.plugins.selectbox');

/**
 * Model for the education field
 *
 * @param {boolean} indeterminate Boolean flag of the indeterminate state
 * @constructor
 * @author Yi Liu (yliu@yext.com)
 */
yext.location.EducationModel = function(indeterminate) {
  this.experiences = [];
  this.indeterminate = indeterminate;
};

/**
 * Update the experience data on the model
 *
 * @param {EducationModel.Experience} experience The experience being updated
 * @param {!Object} update The updated experience
 */
yext.location.EducationModel.prototype.update = function(experience, update) {
  if (experience.update(update)) {
    this.message('updated');
  }
};

/**
 * Remove the experience from the model
 *
 * @param {EducationModel.Experience} experience The experience being updated
 */
yext.location.EducationModel.prototype.remove = function(experience) {
  this.experiences.splice(this.experiences.indexOf(experience), 1);
  this.message('updated');
};

/**
 * Trigger a message on the EducationModel
 *
 * @param {string} message Message to trigger
 */
yext.location.EducationModel.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * The experience model which consists of the selected type, the institution name, and the year
 * @constructor
 */
yext.location.EducationModel.Experience = function(data) {
  this.type = data.type;
  this.institutionName = data.institutionName;
  this.year = data.year;
};

/**
 * Return true if the experience is updated
 *
 * @param {!Object} update The updated experience
 * @return {boolean} True if the institution or year gets updated
 */
yext.location.EducationModel.Experience.prototype.update = function(update) {
  var changed = false;
  if (update.type !== this.type) {
    changed = true;
    this.type = update.type;
  }
  if (update.year !== this.year) {
    changed = true;
    this.year = update.year;
  }
  if (update.institutionName !== this.institutionName) {
    changed = true;
    this.institutionName = update.institutionName;
  }

  return changed;
};

/**
 * Get a copy of the experience data
 *
 * @return {!Object} Model properties
 */
yext.location.EducationModel.Experience.prototype.getData = function() {
  return {
    type: this.type,
    institutionName: this.institutionName,
    year: this.year,
  };
};

/**
 * Data keyed on strings for export
 *
 * @return {!Object} Model properties keyed with strings
 */
yext.location.EducationModel.Experience.prototype.getDataForExport = function() {
  return {
    'type': this.type,
    'institutionName': this.institutionName,
    'year': this.year,
  };
};

/**
 * @param {!jQuery} $ctx Parent element for the field
 * @constructor
 */
yext.location.Education = function($ctx) {
  this.$ctx = $ctx;
  this.$experiences = $ctx.find('.js-experiences-list');
  this.$template = $($ctx.find('.js-education-template').html());
  this.model = new yext.location.EducationModel($ctx.find('.js-field-indeterminate').val() === 'true');
  this.storedModel = {};
  this.typeLabels = this.getTypeLabels();
  this.fieldName = $ctx.find('input[name="field"]').val();

  this.parseExperiencesFromDOM();
  this.getTypeLabels();
  this.storeValue();
  this.bindAdd();
  this.bindUpdates();
  this.bindRemove();
  this.bindReset();
};

/**
 * Parse the initial state of experiences list from the DOM
 */
yext.location.Education.prototype.parseExperiencesFromDOM = function() {
  var self = this;

  this.$experiences.find('.js-experience').each(function() {
    self.parseExperienceFromDOM($(this));
  });
};

/**
 * Parse the initial state of a single experience from the DOM
 *
 * @param {!jQuery} $el The experience element
 */
yext.location.Education.prototype.parseExperienceFromDOM = function($el) {
  var $select = $el.find('select');
  var $institutionName = $el.find('.js-education-institution-name-input');
  var $year = $el.find('.js-education-year-completed-input');

  var experience = new yext.location.EducationModel.Experience({
    type: $select.val(),
    institutionName: $institutionName.val(),
    year: $year.val(),
  });

  $el.data('experience', experience);
  this.model.experiences.push(experience);
  this.bindUpdate($select, $institutionName, $year, experience);
};

/**
 * Bind update on the experience model
 */
yext.location.Education.prototype.bindUpdate = function($select, $institutionName, $year, experience) {
  this.bindSelect($select, experience);
  this.bindInstitutionName($institutionName, experience);
  this.bindYear($year, experience);
};

/**
 * Iterate through select options to get labels to be used
 * in view mode
 *
 * @return {!Object} Select labels keyed with select value
 */
yext.location.Education.prototype.getTypeLabels = function() {
  var labels = {};
  this.$template.find('select option').each(function() {
    var $this = $(this);
    labels[$this.val()] = $this.html();
  });
  return labels;
};

/**
 * Bind the add link
 */
yext.location.Education.prototype.bindAdd = function() {
  var self = this;

  self.$ctx.find('.js-education-add').click(function() {
    var $newExperience = self.$template.clone();
    $newExperience.find('select').selectbox();
    self.$experiences.append($newExperience);
    self.parseExperienceFromDOM($newExperience);
  });
};

/**
 * Bind the type select dropdown
 *
 * @param {!jQuery} $select Select dropdown container
 * @param {EducationModel.Experience} experience The experience being updated
 */
yext.location.Education.prototype.bindSelect = function($select, experience) {
  var self = this;
  $select.on('change', function() {
    var update = {
      type: $(this).val(),
      institutionName: experience.institutionName,
      year: experience.year,
    };
    self.model.update(experience, update);
  });
};

/**
 * Bind the institution name input text box update
 *
 * @param {!jQuery} $institutionName Institution name input container
 * @param {EducationModel.Experience} experience The experience being updated
 */
yext.location.Education.prototype.bindInstitutionName = function($institutionName, experience) {
  var self = this;
  $institutionName.inputchange(function() {
    var update = {
      type: experience.type,
      institutionName: $(this).val(),
      year: experience.year,
    };
    self.model.update(experience, update);
  });
};

/**
 * Bind the year input text box update
 *
 * @param {!jQuery} $year Year input container
 * @param {EducationModel.Experience} experience The experience being updated
 */
yext.location.Education.prototype.bindYear = function($year, experience) {
  var self = this;
  $year.inputchange(function() {
    var update = {
      type: experience.type,
      institutionName: experience.institutionName,
      year: $(this).val(),
    };
    self.model.update(experience, update);
  });
};

/**
 * Bind delete icon
 */
yext.location.Education.prototype.bindRemove = function() {
  var self = this;
  this.$experiences.on('click', '.js-education-remove', function() {
    var experience = $(this).parent().closest('div').data('experience');
    self.model.remove(experience);
  });
};

/**
 * Bind the reset link in bulk edit case
 */
yext.location.Education.prototype.bindReset = function() {
  var self = this;
  this.$ctx.find('.js-reset-education').click(function() {
    self.model.indeterminate = false;
    self.$ctx.find('.js-education-wrap').show();
    self.$ctx.find('.js-indeterminate-message').hide();

    var $newExperience = self.$template.clone();
    $newExperience.find('select').selectbox();
    self.$experiences.empty().append($newExperience);
    self.model.experiences = [];
    self.parseExperienceFromDOM($newExperience);
  });
};

/**
 * Reset the field to a stored state
 */
yext.location.Education.prototype.reset = function() {
  this.set(this.storedModel);
};

/**
 * Set the fields value
 *
 * @param {!Object} field Field data
 */
yext.location.Education.prototype.set = function(field) {
  this.model.experiences = [];
  for (var i = 0; i < field.experiences.length; i++) {
    var experience = new yext.location.EducationModel.Experience(field.experiences[i]);
    this.model.experiences.push(experience);
  }

  this.model.indeterminate = field.indeterminate;

  this.model.message('updated');
};

/**
 * Store the state for use in reset
 */
yext.location.Education.prototype.storeValue = function() {
  this.storedModel = new yext.location.EducationModel(this.model.indeterminate);
  for (var i = 0; i < this.model.experiences.length; i++) {
    this.storedModel.experiences.push(this.model.experiences[i].getData());
  }
};

/**
 * Listen for updates from the model and broadcasts an update message
 */
yext.location.Education.prototype.bindUpdates = function() {
  var self = this;
  $(this.model).on('updated', function() {
    self.render();
    self.message('updated');
  });
};

/**
 * Render the current state of the model
 */
yext.location.Education.prototype.render = function() {
  var self = this;

  if (this.model.indeterminate) {
    this.$ctx.find('.js-education-wrap').hide();
    this.$ctx.find('.js-indeterminate-message').show();
  }

  // Remove any experience from DOM that's not in the model
  this.$experiences.find('.js-experience').each(function() {
    var experience = $(this).data('experience');
    if (self.model.experiences.indexOf(experience) === -1) {
      $(this).remove();
    }
  });

  var $experiencesDOM = this.$experiences.find('.js-experience');
  for (var i = this.model.experiences.length - 1; i >= 0; i--) {
    var experience = this.model.experiences[i];
    var $experienceDOM = $experiencesDOM.get(i);
    if ($experienceDOM) {
      if ($experienceDOM.length && $experienceDOM.data('experience') != experience) {
        this.renderInternal(experience).insertAfter($experienceDOM);
      }
    } else {
      this.$experiences.append(this.renderInternal(experience));
    }
  }
};

/**
 * @param {EducationModel.Experience} experience The experience model used to pop up the template
 * @return {!jQuery} A single experience template
 */
yext.location.Education.prototype.renderInternal = function(experience) {
  var $template = this.$template.clone();
  var $select = $template .find('select');
  var $institutionName = $template .find('.js-education-institution-name-input');
  var $year = $template .find('.js-education-year-completed-input');

  // Pop up the data
  $select.val(experience.type).selectbox();
  $institutionName.val(experience.institutionName);
  $year.val(experience.year);
  $template.data('experience', experience);

  this.bindUpdate($select, $institutionName, $year, experience);

  return $template;
};

/**
 * Broadcast messages with the field as context
 *
 * @param {string} message Message to trigger
 */
yext.location.Education.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Get the display value for the field
 *
 * @return {string} education list html string
 */
yext.location.Education.prototype.getDisplayValue = function() {
  if (this.model.indeterminate) {
    return yext.location.helpers.variousContentMessage();
  } else if (this.model.experiences.length === 0) {
    return yext.location.helpers.emptyFieldMessage();
  } else {
    var display = '<div class="education-list-view">';
    for (var i = 0; i < this.model.experiences.length; i++) {
      var experience = this.model.experiences[i];
      var experienceHtml = '<span class="education-type">' + this.typeLabels[experience.type] + '</span><span class="education-institution-name">' + experience.institutionName + '</span><span class="education-year">' + experience.year + '</span><br/>';
      display += experienceHtml;
    }
    display += '</div>';
    return display;
  }
};

/**
 * Get the current state of the field as a JSON string
 *
 * @return {string} JSON string of field
 */
yext.location.Education.prototype.getJSONData = function() {
  var experiences = [];
  for (var i = 0; i < this.model.experiences.length; i++) {
    experiences.push(this.model.experiences[i].getDataForExport());
  }
  return yext.JSON.stringify({
    'educationList': experiences,
  });
};
